import React from 'react';
import PropTypes from 'prop-types';
import { isPresent } from 'utils/helperMethods';
import { useTranslation } from 'react-i18next';

import useScreen from 'hooks/useScreen';
import Checkbox from 'sharedComponents/Checkbox';
import Avatar from 'sharedComponents/Avatar';
import Icon from 'sharedComponents/Icon';
import Tag from 'sharedComponents/Tag';
import LoanOfficerPresenter from 'presenters/realEstateAgent/LoanOfficerPresenter';

import { Typography, Button } from '@material-ui/core';

import useStyles from './useStyles';

const LoanOfficerCard = props => {
  const { loanOfficer, isSelected, onSelect, onApprove, isApproving } = props;
  const classes = useStyles();
  const { isDesktop } = useScreen();
  const { t } = useTranslation();

  const handleApprove = () => {
    onApprove(loanOfficer.id);
  };

  const apr = LoanOfficerPresenter.readableApr(loanOfficer);
  const responseTime = LoanOfficerPresenter.readableResponseTime(loanOfficer);
  const isAprPresent = isPresent(apr);
  const isResponseTimePresent = isPresent(responseTime);

  return (
    <div className={classes.container}>
      <div className={classes.mainBox}>
        <Checkbox checked={isSelected} onChange={onSelect} value={loanOfficer.id} className={classes.checkBox} />
        <Avatar size="m" imageUrl={LoanOfficerPresenter.profileImageUrl(loanOfficer)} />
        <div className={classes.loanOfficerBadge}>
          <Typography noWrap variant="subtitle1" color="secondary">
            {t('models.App.userTypes.loanOfficer')}
          </Typography>
          <Typography noWrap variant="h3" className={classes.name}>
            {LoanOfficerPresenter.loanOfficerName(loanOfficer)}
          </Typography>
        </div>
        {isDesktop && (
          <div className={classes.loanOfficerInfo}>
            <Typography variant="subtitle1" color="secondary">
              {t('components.RealEstateAgentLoanOfficers.WaitlistLoanOfficersList.LoanOfficerCard.branchLocation')}
            </Typography>
            <Typography noWrap variant="h3" color="inherit" className={classes.label}>
              {LoanOfficerPresenter.branchLocation(loanOfficer)}
            </Typography>
          </div>
        )}
        {isAprPresent && (
          <Tag className={classes.tag} color="red">
            <Typography
              noWrap
              variant="subtitle1"
              dangerouslySetInnerHTML={{
                __html: t('components.RealEstateAgentLoanOfficers.WaitlistLoanOfficersList.LoanOfficerCard.apr', {
                  apr,
                }),
              }}
            />
          </Tag>
        )}
        {isResponseTimePresent && (
          <Tag className={classes.tag}>
            <Typography
              noWrap
              variant="subtitle1"
              dangerouslySetInnerHTML={{
                __html: t(
                  'components.RealEstateAgentLoanOfficers.WaitlistLoanOfficersList.LoanOfficerCard.responseTime',
                  { responseTime },
                ),
              }}
            />
          </Tag>
        )}
      </div>
      <Button
        startIcon={isDesktop && <Icon name="check" className={classes.addIcon} />}
        onClick={handleApprove}
        disabled={isApproving}
        className={classes.approveButton}
      >
        {t('components.RealEstateAgentLoanOfficers.WaitlistLoanOfficersList.LoanOfficerCard.approve')}
      </Button>
    </div>
  );
};

LoanOfficerCard.propTypes = {
  loanOfficer: LoanOfficerPresenter.shape().isRequired,
  isSelected: PropTypes.bool.isRequired,
  onSelect: PropTypes.func.isRequired,
  onApprove: PropTypes.func.isRequired,
  isApproving: PropTypes.bool.isRequired,
};

export default LoanOfficerCard;



// WEBPACK FOOTER //
// ./src/components/RealEstateAgentLoanOfficers/components/WaitlistLoanOfficersList/components/LoanOfficerCard/LoanOfficerCard.js